import axios from "axios";
import * as actionTypes from "./Actiontypes";

const BASE_URL = "https://api.happiclips.com/api";

export const fetchTestimonials = (page = 1, accountType = null) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_TESTIMONIALS_INIT,
    });

    try {
      const authToken = localStorage.getItem("authToken");
      const params = {
        page,
        ...(accountType && { account_type: accountType }),
      };

      const response = await axios.get(`${BASE_URL}/testimonials`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        params,
      });

      dispatch({
        type: actionTypes.FETCH_TESTIMONIALS_SUCCESS,
        payload: response.data.data,
      });
      return response;
    } catch (error) {
      dispatch({
        type: actionTypes.FETCH_TESTIMONIALS_FAIL,
        payload: error.message || "Something went wrong. Please try again.",
      });
    }
  };
};

export const deleteTestimonial = (id) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_TESTIMONIALS_INIT,
    });

    try {
      const authToken = localStorage.getItem("authToken");

      const response = await axios.delete(`${BASE_URL}/testimonial/${id}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      dispatch({
        type: actionTypes.DELETE_TESTIMONIALS_SUCCESS,
        payload: response.data,
      });

      return response;
    } catch (error) {
      dispatch({
        type: actionTypes.DELETE_TESTIMONIALS_FAIL,
        payload: error.message || "Something went wrong. Please try again.",
      });
    }
  };
};
